module.exports = __webpack_public_path__ + "static/media/TTHeaderImahe-1.dc797d65.JPG";